// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3V8zZ","loaderOuter":"PageOverlayLoader_loaderOuter__de9GG"};